import { render, staticRenderFns } from "./description.vue?vue&type=template&id=24b6f1f6&scoped=true&"
import script from "./description.vue?vue&type=script&lang=ts&"
export * from "./description.vue?vue&type=script&lang=ts&"
import style0 from "./description.vue?vue&type=style&index=0&id=24b6f1f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b6f1f6",
  null
  
)

export default component.exports